// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-episode-js": () => import("/opt/build/repo/src/templates/episode.js" /* webpackChunkName: "component---src-templates-episode-js" */),
  "component---src-pages-index-js": () => import("/opt/build/repo/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/opt/build/repo/.cache/data.json")

